"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObjects = exports.getSchemaPropertiesKeys = exports.removeJsonByPath = exports.safeStringify = exports.cloneObject = exports.convertDictionaryArrays = exports.filterNullOrUndefined = exports.removeLastPropertyName = exports.getLastPropertyName = exports.convertDotNotationPathToJsonSchemaPath = exports.convertJsonSchemaPathToDataPath = exports.getDataByJsonPath = exports.searchJsonUpwards = exports.unFlattenJson = exports.flattenJson = exports.hasJsonProperty = exports.setJsonProperty = exports.getParentJson = exports.getJsonByPath = exports.isEmptyObject = void 0;
const class_validator_1 = require("class-validator");
const utils_1 = require("./utils");
/** returns true for `{}` */
function isEmptyObject(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object" || obj instanceof Array)
        return false;
    return Object.keys(obj).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function getJsonByPath(json, path) {
    if (!json)
        return undefined;
    if (!path || utils_1.Utils.isEmptyString(path))
        return json;
    let currentJson = json;
    const singlePaths = path.split(".");
    for (const currentPath of singlePaths) {
        if (currentJson instanceof Array) {
            if ((0, class_validator_1.isNumberString)(currentPath))
                currentJson = currentJson[parseInt(currentPath)];
            else
                currentJson = currentJson
                    .map((value) => {
                    return getJsonByPath(value, currentPath);
                })
                    .flat()
                    .filter((v) => v !== undefined);
        }
        else if (currentJson !== undefined)
            currentJson = currentJson[currentPath];
        if (currentJson === undefined)
            return undefined;
    }
    return currentJson;
}
exports.getJsonByPath = getJsonByPath;
function getParentJson(json, path, depth = 1) {
    let parentJson;
    for (let i = 0; i < depth; i++) {
        if (!path)
            return json;
        if (!path.includes("."))
            return json;
        path = path.substring(0, path.lastIndexOf("."));
        parentJson = getJsonByPath(json, path);
    }
    return parentJson;
}
exports.getParentJson = getParentJson;
/** replaces the given property in the given json and returns it. You can use array.1.bla to manipulate an array */
function setJsonProperty(json, path, value) {
    if (!json)
        json = {};
    if (value === undefined || isEmptyObject(value)) {
        return removeJsonByPath(json, path);
    }
    else {
        json = cloneObject(json);
        const flatJson = flattenJson(json);
        flatJson[path] = value;
        return unFlattenJson(flatJson);
    }
}
exports.setJsonProperty = setJsonProperty;
/** returns true if property is not undefined */
function hasJsonProperty(json, path) {
    const data = getJsonByPath(json, path);
    return !!data;
}
exports.hasJsonProperty = hasJsonProperty;
/**
 * Creates a very flat array by using dot notation instead of sub objects
 *
 * @param data Pass an object that you want to flatten
 * @param flattenArrays Defaults to true. If set to false, arrays will be kept as they are. Please notice, that flattened objects with unflattened arrays cannot use the function `unflattenJson`.
 * @returns
 */
function flattenJson(data, flattenArrays = true) {
    const result = {};
    function recurse(current, prop) {
        if (Object(current) !== current) {
            result[prop] = current;
        }
        else if (Array.isArray(current)) {
            if (flattenArrays === true) {
                for (let i = 0, l = current.length; i < l; i++)
                    recurse(current[i], `${prop}.${i}`);
            }
            else {
                result[prop] = current;
            }
        }
        else {
            let isEmpty = true;
            for (const p in current) {
                if (current.hasOwnProperty(p)) {
                    isEmpty = false;
                    recurse(current[p], prop ? `${prop}.${p}` : p);
                }
            }
            if (isEmpty && prop)
                result[prop] = {};
        }
    }
    recurse(data, "");
    return result;
}
exports.flattenJson = flattenJson;
function unFlattenJson(data) {
    if (Object(data) !== data || Array.isArray(data))
        return data;
    const regex = /\.?([^.[\]]+)|\[(\d+)\]/g;
    const resultholder = {};
    for (const p in data) {
        if (data.hasOwnProperty(p)) {
            let cur = resultholder;
            let prop = "";
            let m;
            // eslint-disable-next-line no-cond-assign
            while ((m = regex.exec(p))) {
                cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
                prop = m[2] || m[1];
            }
            cur[prop] = data[p];
        }
    }
    return convertDictionaryArrays(resultholder[""] || resultholder);
}
exports.unFlattenJson = unFlattenJson;
function searchJsonUpwards(json, currentPath, searchPath) {
    const currentJson = getJsonByPath(json, currentPath);
    // root?
    if (!currentPath.includes(".")) {
        if (getJsonByPath(currentJson, searchPath) !== undefined)
            return json;
        else
            return undefined;
    }
    currentPath = currentPath.substring(0, currentPath.lastIndexOf("."));
    if (getJsonByPath(currentJson, searchPath))
        return currentJson;
    return searchJsonUpwards(json, currentPath, searchPath);
}
exports.searchJsonUpwards = searchJsonUpwards;
function getDataByJsonPath(data, path) {
    // normalize path
    path = path.replace(/properties\./g, "");
    return flattenJson(data)[path];
}
exports.getDataByJsonPath = getDataByJsonPath;
/**
 * Converts a schema path (properties.address.properties.street) to a data path (address.street)
 */
function convertJsonSchemaPathToDataPath(schemaPath) {
    return schemaPath === null || schemaPath === void 0 ? void 0 : schemaPath.replace(/properties\./g, "").replace(/#/g, ".");
}
exports.convertJsonSchemaPathToDataPath = convertJsonSchemaPathToDataPath;
/**
 * Converts a dot notation path (e.g. address.street) to a schema path (properties.address.properties.street)
 */
function convertDotNotationPathToJsonSchemaPath(dataPath) {
    if (!dataPath)
        return "";
    return dataPath
        .split(".")
        .map((split) => {
        // Array qualifier?
        if (utils_1.Utils.isNumberString(split))
            return `items`;
        return `properties.${split}`;
    })
        .join(".");
}
exports.convertDotNotationPathToJsonSchemaPath = convertDotNotationPathToJsonSchemaPath;
/**
 * returns the last portion of the schema path
 */
function getLastPropertyName(schemaPath) {
    if (!schemaPath)
        return schemaPath;
    if (!schemaPath.includes("."))
        return schemaPath;
    return schemaPath.substring(schemaPath.lastIndexOf(".") + 1);
}
exports.getLastPropertyName = getLastPropertyName;
function removeLastPropertyName(path) {
    if (!path || !path.includes("."))
        return undefined;
    return path.substring(0, path.lastIndexOf("."));
}
exports.removeLastPropertyName = removeLastPropertyName;
/**
 * removes keys that have an undefined or null value
 */
function filterNullOrUndefined(obj) {
    const clonedObj = cloneObject(obj);
    Object.keys(clonedObj).forEach((k) => {
        if (clonedObj[k] && typeof clonedObj[k] === "object")
            clonedObj[k] = filterNullOrUndefined(clonedObj[k]);
        else if (clonedObj[k] === null || clonedObj[k] === undefined)
            delete clonedObj[k];
    });
    return clonedObj;
}
exports.filterNullOrUndefined = filterNullOrUndefined;
/** converts dictionary arrays to normal arrays, also works for nested arrays */
function convertDictionaryArrays(obj) {
    obj = cloneObject(obj);
    for (const key of Object.keys(obj)) {
        if (typeof key === "string") {
            if (typeof obj[key] === "object") {
                // check if all sub keys are numbers
                let onlyNumbers = true;
                if (obj[key]) {
                    for (const subKey of Object.keys(obj[key])) {
                        if (!(0, class_validator_1.isNumberString)(subKey))
                            onlyNumbers = false;
                    }
                    if (onlyNumbers)
                        obj[key] = Object.values(obj[key]);
                    obj[key] = convertDictionaryArrays(obj[key]);
                }
            }
        }
    }
    return obj;
}
exports.convertDictionaryArrays = convertDictionaryArrays;
/**
 * Clones an object via JSON.parse(JSON.stringify(obj))
 */
function cloneObject(obj) {
    if (obj !== undefined && obj !== null)
        return JSON.parse(JSON.stringify(obj));
    return obj;
}
exports.cloneObject = cloneObject;
/** stringifies without circular references */
function safeStringify(obj, indent = 2) {
    let cache = [];
    const retVal = JSON.stringify(obj, (key, value) => typeof value === "object" && value !== null
        ? cache.includes(value)
            ? undefined // Duplicate reference found, discard key
            : cache.push(value) && value // Store value in our collection
        : value, indent);
    cache = null;
    return retVal;
}
exports.safeStringify = safeStringify;
function removeJsonByPath(json, path) {
    if (!json || !path)
        return;
    json = cloneObject(json);
    const flatJson = flattenJson(json);
    for (const key of Object.keys(flatJson)) {
        const pathSplit = key.split(".");
        let currentPath;
        for (let i = 0; i < pathSplit.length; i++) {
            if (currentPath)
                currentPath += ".";
            else
                currentPath = "";
            currentPath += pathSplit[i];
            if (currentPath === path) {
                delete flatJson[key];
                break;
            }
        }
    }
    return unFlattenJson(flatJson);
}
exports.removeJsonByPath = removeJsonByPath;
/** generates a list of all known schema properties */
function getSchemaPropertiesKeys(schema, subPath) {
    if (schema.properties) {
        const properties = Object.keys(schema.properties).map((val) => (subPath ? subPath + "." + val : val));
        for (const propName in schema.properties) {
            if (schema.properties[propName] && schema.properties[propName].properties)
                properties.push(...getSchemaPropertiesKeys(schema.properties[propName], propName));
        }
        return properties;
    }
    else
        return [];
}
exports.getSchemaPropertiesKeys = getSchemaPropertiesKeys;
/** deeply merges two objects */
function mergeObjects(obj1, obj2) {
    if (obj1 === undefined || obj1 === null)
        return obj2;
    if (obj2 === undefined || obj2 === null)
        return obj1;
    return unFlattenJson(Object.assign(Object.assign({}, flattenJson(obj1)), flattenJson(obj2)));
}
exports.mergeObjects = mergeObjects;
